import { render } from "./Task_categories.vue?vue&type=template&id=308f73fb"
import script from "./Task_categories.vue?vue&type=script&lang=js"
export * from "./Task_categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__